function initiateCraftGinAddToCart() {
  document.querySelectorAll('.my-craft-gin-add-to-cart-block').forEach((block) => {
    new window.MyCraftGinAddToCart(block);
  });
}

if (!window.MyCraftGinAddToCart) {
  window.MyCraftGinAddToCart = class MyCraftGinAddToCart {
    constructor(blockElement) {
      this.blockElement = blockElement;
      this.addToCartButton = blockElement.querySelector('.add-to-cart-button');
      this.buyNowButton = blockElement.querySelector('.buy-now-button');
      this.cartForm = blockElement.querySelector('.cart-form');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.validationContainer = blockElement.querySelector('.validation-messages');
      this.priceElements = {
        base: blockElement.querySelector('[data-base-price]'),
        extras: blockElement.querySelector('[data-extras-price]'),
        total: blockElement.querySelector('[data-total-price]'),
      };

      this.startVariant = JSON.parse(blockElement.dataset.product);
      this.variantsArray = window.__CGC.craftSpiritVariants;

      this.inputs = {
        author: null,
        name: null,
        tagLine: null,
      };

      // Get settings from block data attributes
      this.settings = {
        requiredBotanicals: parseInt(blockElement.dataset.requiredBotanicals) || 5,
        requireGinType: blockElement.dataset.requireGinType !== 'false',
        requireBottleCount: blockElement.dataset.requireBottleCount !== 'false',
      };

      // Selection state
      this.selections = {
        botanicals: [],
        ginType: null,
        ginSubsequentOption: null,
        bottleCount: this.startVariant.option1 || null,
        giftWrap: this.startVariant.option2 || false,
        flakes: this.startVariant.option3.toLowerCase() == 'yes' || false,
      };

      this.prices = {
        base: parseInt(this.priceElements.base.dataset.basePrice) || 0,
        current: parseInt(this.priceElements.base.dataset.basePrice) || 0,
      };

      this.labelType = 'Normal Label';
      this.compulsoryProperties = ['coriander seed', 'angelica'];
      this.flake_colour = 'Gold';

      this.init();
    }

    init() {
      this.addEventListeners();
      this.handleVariantChange();
      this.validateSelections();
    }

    addEventListeners() {
      // Listen for input field updates
      document.addEventListener('input-changed', (e) => {
        this.updateInputs(e.detail.input);
        this.validateSelections();
      });

      // Listen for label type updates
      document.addEventListener('my-craft-spirit-label-changed', (e) => {
        this.labelType = e.detail.labelType;
      });

      // Listen for custom events from botanicals and gin type components
      document.addEventListener('botanicals-changed', (e) => {
        this.selections.botanicals = e.detail.selectedBotanicals;
        this.validateSelections();
      });

      document.addEventListener('gin-type-changed', (e) => {
        this.selections.ginType = e.detail.selectedType;

        if (!e.detail.selectedSubsequentOption) {
          switch (this.selections.ginType.toLowerCase()) {
            case 'old-tom-gin':
              this.selections.ginSubsequentOption = 'sugar';
              break;
            case 'fruit-infused-gin':
              this.selections.ginSubsequentOption = 'raspberry - pink';
              break;
            case 'pink-gin':
              this.selections.ginSubsequentOption = 'strawberry';
              break;
            default:
              this.selections.ginSubsequentOption = '';
          }
        } else {
          this.selections.ginSubsequentOption = e.detail.selectedSubsequentOption;
        }

        this.validateSelections();
      });

      document.addEventListener('quantity-changed', (e) => {
        this.selections.bottleCount = e.detail.value;
        this.handleVariantChange();
      });

      document.addEventListener('gift-wrapped-changed', (e) => {
        this.selections.giftWrap = e.detail.value;

        this.handleVariantChange();
        this.validateSelections();
      });

      document.addEventListener('add-glitter-changed', (e) => {
        this.selections.flakes = e.detail.value.toLowerCase() == 'yes' ? true : false;
        this.handleVariantChange();
        this.validateSelections();
      });

      document.addEventListener('flake_colour-changed', (e) => {
        this.flake_colour = e.detail.value;
        this.validateSelections();
      });

      // Add to basket button
      this.addToCartButton.addEventListener('click', () => {
        this.addToCart();
      });

      // Buy now button
      if (this.buyNowButton) {
        this.buyNowButton.addEventListener('click', () => {
          this.buyNow();
        });
      }
    }

    updateInputs(input) {
      const field = input.name.replaceAll('properties[', '').replaceAll(']', '');
      this.inputs[field] = input.value;
    }

    handleVariantChange() {
      const selectedOption = `${this.selections.bottleCount}_${this.selections.giftWrap}_${
        this.selections.flakes ? 'yes' : 'no'
      }`;
      const variant = this.variantsArray[selectedOption.replaceAll(' ', '_').toLocaleLowerCase()];

      if (!variant) return;

      this.prices.current = +variant.price || 0;

      const variantIdInput = this.cartForm.querySelector('[name="id"]');
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }

      this.updatePricing();
      this.validateSelections();
    }

    extractVariantOption(variant, optionName) {
      // Try to find the option by matching with variant options
      if (variant.options) {
        const optionIndex = variant.product?.options?.findIndex((opt) => opt.name === optionName);
        if (optionIndex !== -1 && variant.options[optionIndex]) {
          return variant.options[optionIndex];
        }
      }

      // Fallback: try to extract from variant title
      if (variant.title && variant.title.includes('/')) {
        const options = variant.title.split(' / ');
        // This is a simple fallback - you may need to adjust based on your variant title structure
        return options.find((opt) => opt.includes(optionName.split(' ')[0]));
      }

      return null;
    }

    getCurrentVariant() {
      // Get current variant from product form or variant picker
      const productForm = document.querySelector('[action*="/cart/add"]');
      if (productForm) {
        const variantIdInput = productForm.querySelector('[name="id"]');
        if (variantIdInput && window.product && window.product.variants) {
          return window.product.variants.find((v) => v.id == variantIdInput.value);
        }
      }
      return null;
    }

    validateSelections() {
      const validations = [];

      if (!this.inputs.author) {
        validations.push('author');
      }

      if (!this.inputs.name) {
        validations.push('name');
      }

      if (!this.inputs.tagline) {
        validations.push('tagline');
      }

      // Check botanicals
      if (
        this.settings.requiredBotanicals > 0 &&
        this.selections.botanicals.length < this.settings.requiredBotanicals
      ) {
        validations.push('botanicals');
      }

      // Check gin type
      if (this.settings.requireGinType && !this.selections.ginType) {
        validations.push('gin-type');
      }

      // Bottle count is now handled by Shopify variants, so we don't need to validate it separately
      // The variant picker will ensure a valid variant is selected

      this.updateValidationDisplay(validations);

      const isValid = validations.length === 0;
      this.addToCartButton.disabled = !isValid;
      if (this.buyNowButton) {
        this.buyNowButton.disabled = !isValid;
      }

      return isValid;
    }

    updateValidationDisplay(validations) {
      const validationMessages = this.blockElement.querySelectorAll('.validation-message');

      // Hide all validation messages first
      validationMessages.forEach((msg) => {
        msg.style.display = 'none';
      });

      // Show container if there are validations
      if (validations.length > 0) {
        this.validationContainer.style.display = 'block';

        // Show specific validation messages
        validations.forEach((validation) => {
          const msg = this.blockElement.querySelector(`[data-validation="${validation}"]`);
          if (msg) {
            msg.style.display = 'flex';
          }
        });
      } else {
        this.validationContainer.style.display = 'none';
      }
    }

    updatePricing() {
      // The variant price includes all options, so we use that as the total
      const total = this.prices.current;
      const extrasCost = this.prices.current - this.prices.base;

      // Update DOM
      this.priceElements.extras.textContent = this.formatPrice(extrasCost);
      this.priceElements.extras.parentElement.style.display = extrasCost > 0 ? 'flex' : 'none';

      this.priceElements.total.textContent = this.formatPrice(total);
      this.priceElements.total.dataset.totalPrice = total;
    }

    formatPrice(priceInCents) {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
      }).format(priceInCents / 100);
    }

    async addToCart() {
      if (!this.validateSelections()) return;

      this.setLoading(true);

      try {
        const formData = this.buildFormData();

        const craftSpiritCheckout = new CraftSpiritCheckout(this, formData);
        await craftSpiritCheckout.addToCart();

        const containerModal = this.blockElement.closest('quick-add-modal');
        if (containerModal) {
          containerModal.hide();
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert('Sorry, there was an error adding this item to your cart. Please try again.');
      } finally {
        this.setLoading(false);
      }
    }

    async buyNow() {
      if (!this.validateSelections()) return;

      this.setLoading(true);

      try {
        await this.addToCart();
        // Redirect to checkout
        window.location.href = '/checkout';
      } catch (error) {
        this.setLoading(false);
      }
    }

    buildFormData() {
      const glitter = this.selections.flakes ? this.flake_colour : 'None';

      const formData = new FormData(this.cartForm);

      formData.append('properties[label]', this.labelType);
      formData.append('properties[author]', this.inputs.author || '');
      formData.append('properties[name]', this.inputs.name || '');
      formData.append('properties[tagLine]', this.inputs.tagline || '');
      formData.append('properties[type]', this.selections.ginType || 'london dry gin');
      formData.append('properties[compulsory]', this.compulsoryProperties);
      formData.append('properties[infusion]', this.selections.ginSubsequentOption || '');
      formData.append('properties[botanicals]', this.selections.botanicals || []);
      formData.append('properties[glitter]', glitter);
      formData.append('properties[wrap]', this.selections.giftWrap || 'No');

      return formData;
    }

    setLoading(loading) {
      const buttonText = this.addToCartButton.querySelector('.button-text');
      const spinner = this.addToCartButton.querySelector('.loading-spinner');

      if (loading) {
        buttonText.style.display = 'none';
        spinner.style.display = 'block';
        this.addToCartButton.disabled = true;
      } else {
        buttonText.style.display = 'block';
        spinner.style.display = 'none';
        this.addToCartButton.disabled = !this.validateSelections();
      }
    }

    async refreshCart() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        // Dispatch cart updated event
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart },
          }),
        );
        return cart;
      } catch (error) {
        console.error('Error refreshing cart:', error);
      }
      return null;
    }
  };
  initiateCraftGinAddToCart();
}

document.addEventListener('DOMContentLoaded', () => {
  initiateCraftGinAddToCart();
});

document.addEventListener('modal-opened', () => {
  initiateCraftGinAddToCart();
});
